<template>
  <div>
    <div class="bottomBox">
      <!-- <p> 河南省豫资大数据研究院有限公司版权所有，未经书面授权禁止使用  <br /> Copyright © 2022-2023 by www.train.hnzyxsbh.com all rights reserved </p> -->
      <p>
         Copyright © 河南省豫资大数据研究院有限公司版权所有 All Rights Reserved.
        版权所有，未经书面授权禁止使用
      </p>
      <p>
        ICP备案/许可证号：
        <a href="https://beian.miit.gov.cn/" target="_blank" data-v-838e4485=""
          >豫ICP备2025115454号</a
        >
      </p>
      <!-- <div class="cinonimg">
        <img src="@/assets/button/copy_icon1.png" alt="" srcset="">
           <img src="@/assets/button/copy_icon2.png" alt="" srcset="">
              <img src="@/assets/button/copy_icon3.png" alt="" srcset="">
                 <img src="@/assets/button/copy_icon4.png" alt="" srcset="">
                    <img src="@/assets/button/copy_py2.png" alt="" srcset="">
                       <img src="@/assets/button/wzahg.png" alt="" srcset="">
      </div> -->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.bottomBox {
  // padding-top: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-left: -10px;
  margin-right: -10px;
  // width: 100%;
  align-content: center;
  height: 61px;
  padding: 9px 0;
  text-align: center;
  line-height: 22px;
  font-size: 14px;
  color: #999;
  background: #fff;
  a {
    color: #999;
  }
}
.cinonimg {
  width: 100%;
  padding: 1% 15%;
  display: flex;
  justify-content: space-around;
}
</style>
